module.exports = __webpack_public_path__ + "img/miscellaneous_attachments_references.d4e2424d.jpg";